import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbIconLibraries } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})

export class AppComponent implements OnInit {
  public options = {
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 7,
    showProgressBar: true,
    pauseOnHover: true,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    rtl: false,
    animate: 'scale',
    position: ['bottom', 'right']
  };

  constructor(private analytics: AnalyticsService, private iconLibraries: NbIconLibraries, private translate: TranslateService) {
    this.iconLibraries.registerFontPack('font-awesome', { packClass: 'fa', iconClassPrefix: 'fa' });
    this.iconLibraries.registerFontPack('font-awesome-regular', { packClass: 'far', iconClassPrefix: 'far' });
    this.iconLibraries.setDefaultPack('font-awesome');

    const userPreferredLanguage = localStorage.getItem('UserPreferredLanguage');
    this.translate.addLangs(['nl', 'de', 'en']);
    this.translate.setDefaultLang('nl');
    this.translate.use(userPreferredLanguage || translate.getBrowserLang() || 'nl');

    Sentry.addIntegration(
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: "system",
        isNameRequired: true,
        isEmailRequired: true,
        showBranding: false,
        triggerLabel: this.translate.instant('FEEDBACK.LABEL'),
        triggerAriaLabel: this.translate.instant('FEEDBACK.LABEL'),
        formTitle: this.translate.instant('FEEDBACK.FORMULIER.TITEL'),
        submitButtonLabel: this.translate.instant('FEEDBACK.FORMULIER.BUTTON.VERSTUREN'),
        cancelButtonLabel: this.translate.instant('FEEDBACK.FORMULIER.BUTTON.ANNULEREN'),
        confirmButtonLabel: this.translate.instant('FEEDBACK.FORMULIER.BUTTON.BEVESTIGEN'),
        addScreenshotButtonLabel: this.translate.instant('FEEDBACK.FORMULIER.BUTTON.SCHERMAFBEELDING.VERWIJDEREN'),
        removeScreenshotButtonLabel: this.translate.instant('FEEDBACK.FORMULIER.BUTTON.SCHERMAFBEELDING.VERWIJDEREN'),
        nameLabel: this.translate.instant('FEEDBACK.FORMULIER.NAAM.LABEL'),
        namePlaceholder: this.translate.instant('FEEDBACK.FORMULIER.NAAM.PLACEHOLDER'),
        emailLabel: this.translate.instant('FEEDBACK.FORMULIER.EMAIL.LABEL'),
        emailPlaceholder: this.translate.instant('FEEDBACK.FORMULIER.EMAIL.PLACEHOLDER'),
        isRequiredLabel: this.translate.instant('FEEDBACK.FORMULIER.VELD_VERPLICHT'),
        messageLabel: this.translate.instant('FEEDBACK.FORMULIER.BERICHT.LABEL'),
        messagePlaceholder: this.translate.instant('FEEDBACK.FORMULIER.BERICHT.PLACEHOLDER'),
        successMessageText: this.translate.instant('FEEDBACK.FORMULIER.SUCCESBERICHT'),
      })
    );
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
  }
}
